import { type MutationHookOptions, useMutation } from "@apollo/client";
import { FinishStreamMutation } from "../graphql/mutations";
import type {
  FinishStreamMutationType,
  FinishStreamMutationVariablesType,
} from "@/types/graphql/partner.generated";

export const useFinishStreamMutation = (
  options?: MutationHookOptions<
    FinishStreamMutationType,
    FinishStreamMutationVariablesType
  >
) => {
  return useMutation<
    FinishStreamMutationType,
    FinishStreamMutationVariablesType
  >(FinishStreamMutation, options);
};
